import { createServerFn } from "@tanstack/react-start";
import type { AnswerContent } from "@/lib/answerPages.functions";
import { resolveAnswerParams } from "@/lib/answersSeo";

type Input = { sector?: string; question?: string; lang?: string };

export interface AnswerPreviewSsrResult {
  content: AnswerContent | null;
}

export const getAnswerPreviewSsr = createServerFn({ method: "POST" })
  .inputValidator((data: Input) => ({
    sector: String(data?.sector ?? "").slice(0, 120),
    question: String(data?.question ?? "").slice(0, 180),
    lang: data?.lang === "en" ? "en" : "es" as "es" | "en",
  }))
  .handler(async ({ data }): Promise<AnswerPreviewSsrResult> => {
    const resolved = resolveAnswerParams(data.sector, data.question, data.lang);
    if (!resolved) return { content: null };
    const { loadAnswerPreviewContent } = await import("@/lib/answerPages.server");
    const content = await loadAnswerPreviewContent({ questionId: resolved.question.id, sectorKey: resolved.sector.key, lang: data.lang });
    return { content };
  });